import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  error: {},
  refreshList: false,
  loading: false,
  globalSearchValue: "",
};

const SearchSlice = createSlice({
  name: "SearchSlice",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSearchValue: (state, action) => {
      state.globalSearchValue = action.payload;
    },
  },
  extraReducers: (builder) => {},
});

export const { setLoading, setSearchValue } = SearchSlice.actions;

export default SearchSlice.reducer;
